<template>
  <div>
    <div class="row" style="margin: 1rem -.5rem;">
      <div class="col-6 d-flex align-items-center">
        <h5 style="margin: 0; color: green;">{{ customer.customer.name }}</h5>
      </div>
      <div class="col-6 justify-content-center d-flex align-items-center flex-column">
        <h6>تاریخ تحویل:</h6>
        <h6 class="font-weight-bold">{{ customer.deliveryDate }}</h6>
      </div>
      <!--<div class="col-4 d-flex align-items-center justify-content-end">-->
      <!--<i class="fa fa-ellipsis-h clickable drag-handler"></i>-->
      <!--</div>-->
    </div>
    <div v-if="showMenu" class="row">
      <div
        class="col-12"
      >Lorem ipsum dolor sit amet, consectetur adipisicing elit. Assumenda atque excepturi, magnam ratione similique tempore? Alias deserunt nam nihil numquam vero. Asperiores at atque enim fuga minima nam quisquam. Aliquam.</div>
    </div>
    <hr>
    <div class="row" v-if="show">
      <div class="col-12">
        <div class="row">
          <div class="col-12">
            <h6>نیازمندی:</h6>
          </div>
        </div>
        <div class="row">
          <div class="col-12 text-center">
            <h4>
              <span class="requested">{{ customer.unitVal }}</span>/
              <span class="assigned">{{ customer.assigned }} واحد</span>
            </h4>
          </div>
          <div class="col-12 text-center">
            <h5
              v-if="customer.unitVal !== customer.assigned"
              class="red"
            >کسری انبار: {{ customer.unitVal - customer.assigned }}</h5>
            <h5
              @click="createVoucher"
              v-if="customer.unitVal === customer.assigned"
              class="iconed-right green clickable"
            >
              <i class="fa fa-check-square-o align-middle"></i>
              <span>صدور سند</span>
            </h5>
          </div>
        </div>
        <hr>
        <div
          class="row"
          v-for="item in customer.materials"
          v-if="customer.unitVal !== customer.assigned"
        >
          <div class="col-7 text-right">
            <h6 class="iconed-left m-0">
              <span>{{ item.name }}</span>
              <i v-if="item.requiredMaterial <= item.assignable" class="fa fa-check green"></i>
            </h6>
          </div>
          <div class="col-5 text-left">
            <h6
              v-if="item.requiredMaterial > item.assignable"
              class="m-0 red"
            >{{ item.requiredMaterial }}/{{ item.assignable }} واحد</h6>
            <h6 v-else class="iconed-right m-0 green">
              <span>{{ item.requiredMaterial }} واحد</span>
            </h6>
          </div>
          <div style="border-bottom: 1px dotted black;
    margin: .5rem 0;
    width: 100%;"></div>
        </div>
      </div>
    </div>
    <!--<div class="row" v-for="item in category.items" :key="item.id">-->
    <!--<div class="col-12">-->
    <!--{{ item.title }} {{ item.id }}-->
    <!--</div>-->
    <!--</div>-->
  </div>
</template>

<script>
import * as $ from "jquery";
import EventBus from "../../_framework/bus.js";
import BaseService from "../../_framework/api/BaseService.js";
import Moment from "moment-jalali";

export default {
  name: "order-col",
  props: ["customer", "product", "materials"],
  data() {
    return {
      show: true,
      showMenu: false,
      newAssignedValue: 0
    };
  },
  mounted() {
    EventBus.$on("rerenderCol", () => {
      this.show = false;
      this.show = true;
    });
  },
  methods: {
    createVoucher() {
      // console.log(this.customer);
      let punit = {};
      new BaseService("products").getById(this.product.id).then(rs => {
        punit = rs.data.unit;
        let data = {
          voucherDate: Moment().format("jYYYY/jMM/jDD"),
          documentType: {
            // id: 16,
            // name: "فروش",
            type: { name: "خروجی", value: 2 }
          },
          serveOutSourceId: 0,
          serveName: localStorage.getItem("company"),
          receiveOutSourceId: this.customer.customer.outSourceId,
          receiveCompanyId: this.customer.customer.companyId,
          receiverName: this.customer.customer.name,
          orderCode: this.customer.orderCode,
          products: [
            {
              productId: this.product.id,
              productName: this.product.name,
              unitVal: this.customer.unitVal, // requested amount of products from company
              unit: punit
            }
          ]
        };
        let _mode = "create";
        let _data = JSON.stringify(data);
        this.$router.push({
          path: "/voucher",
          query: { _mode, _data }
        });
      });
    },
    menuBtnClicked() {
      this.showMenu = !this.showMenu;
    },
    onNewAssignedValueFocus() {
      this.newAssignedValue = "";
    }
  },
  watch: {
    newAssignedValue(val) {
      if (val > this.category.items[0].required) {
        this.newAssignedValue =
          this.category.items[0].required - this.category.items[0].assigned;
      }
    }
  },
  computed: {}
};
</script>

<style lang="scss">
.scrolling-wrapper {
  width: 100%;
  left: 0;
  right: 0;
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
  flex-direction: row;
}

#bottomScrollingWrapper::-webkit-scrollbar {
  display: none;
}

.task-card {
  color: white;
  border-radius: 0.4rem;
  padding: 2rem;
  margin: 0.5rem;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
  transition: 0.3s;
  cursor: pointer;

  &:hover {
    background-color: #aaaaaa;
  }
}
</style>
